<template>
  <div id="UpLoadFile">
    <div v-if="isSubmit">
      <ul class="fileList">
        <draggable group="article" :value="fileList" @input="handleListChange($event)">
          <li v-for="item in fileList" :key="item.name" @click="showFile(item)">
            <div class="FileBox">
              <img
                src="../assets/image/icon_pdf@2x.png"
                v-if="item.type==='pdf' || item.type==='PDF'"
                alt
              />
              <img
                src="../assets/image/icon_JPG@2x.png"
                v-else-if="item.type==='png' || item.type==='PNG' || item.type==='JPG'|| item.type==='jpg' || item.type==='JPEG'  || item.type==='jpeg'|| item.type==='gif'|| item.type==='GIF'"
                alt
              />
              <img
                src="../assets/image/icon_MP4@2x.png"
                v-else-if="item.type==='mp4' || item.type==='MP4' || item.type==='avi'|| item.type==='AVI' || item.type==='MPG'|| item.type==='mpg'  || item.type==='WMV'|| item.type==='wmv'|| item.type==='MOV'|| item.type==='mov' "
                alt
              />
              <img src="../assets/image/icon_DOCX@2x.png" v-else alt />
              <span :title="item.name" class="overFlowFileName">{{item.name}}</span>
            </div>
            <el-button @click.stop="removeItem(item)">删除</el-button>
          </li>
        </draggable>
      </ul>
      <!-- <el-upload
        class="upload-demo"
        action="#"
        multiple
        drag
        :before-upload="handleBefore"
        style="margin-top:10px;margin-bottom:35px"
      >
        <img style="width:19px" src="../assets/image/icon_sc@2x.png" alt />
        <span style="font-size:14px;color:#128bf1;vertical-align: top;">点击上传文件</span>
      </el-upload>-->
      <el-upload
        class="upload-demo"
        action="https://upload-z2.qiniup.com"
        multiple
        drag
        :data="postData"
        :before-upload="beforeAvatarUpload"
        :on-success="handleAvatarSuccess"
        :on-error="handleError"
        style="margin-top:10px;margin-bottom:35px"
      >
        <img style="width:19px" src="../assets/image/icon_sc@2x.png" alt />
        <span style="font-size:14px;color:#128bf1;vertical-align: top;">点击上传文件</span>
      </el-upload>
    </div>
    <ul class="fileList" v-else>
      <li v-for="item in detailsImgList" @click="showFile(item)">
        <div class="FileBox">
          <img
            src="../assets/image/icon_pdf@2x.png"
            v-if="item.type==='pdf' || item.type==='PDF'"
            alt
          />
          <img
            src="../assets/image/icon_JPG@2x.png"
            v-else-if="item.type==='png' || item.type==='PNG' || item.type==='JPG'|| item.type==='jpg' || item.type==='JPEG'  || item.type==='jpeg'|| item.type==='gif'|| item.type==='GIF'"
            alt
          />
          <img
            src="../assets/image/icon_MP4@2x.png"
            v-else-if="item.type==='mp4' || item.type==='MP4' || item.type==='avi'|| item.type==='AVI' || item.type==='MPG'|| item.type==='mpg'  || item.type==='WMV'|| item.type==='wmv'|| item.type==='MOV'|| item.type==='mov' "
            alt
          />
          <img src="../assets/image/icon_DOCX@2x.png" v-else alt />
          <span :title="item.name" class="overFlowFileName">{{item.name}}</span>
        </div>
        <el-button @click.stop="downloadFile(item)">下载</el-button>
      </li>
    </ul>
  </div>
</template>
<script>
import Draggable from 'vuedraggable'
import { Loading } from 'element-ui' //项目已经全局引入element的话可以不单独引入
export default {
  data() {
    return {
      token: '',
      member_id: '',
      fileList: [],
      // 七牛上传相关
      postData: {
        token: '',
        key: '',
      },
      loadingData: [],
      upload_qiniu_addr: 'http://qiniu.sxpz.vip/',
    }
  },
  components: {
    Draggable,
  },
  props: ['imgList', 'isSubmit', 'detailsImgList'],
  mounted() {},
  methods: {
    handleListChange(event) {
      this.fileList = event
      console.log(this.fileList)
      this.$emit('my-upload-change', this.fileList)
    },
    showFile(item) {
      if (
        item.type == 'pdf' ||
        item.type == 'PDF' ||
        item.type == 'jpeg' ||
        item.type == 'JPEG' ||
        item.type == 'MP4' ||
        item.type == 'mp4' ||
        item.type == 'png' ||
        item.type == 'PNG' ||
        item.type == 'mp4' ||
        item.type == 'jpg' ||
        item.type == 'JPG'
      ) {
        window.open(item.url)
      } else if (
        item.type == 'xls' ||
        item.type == 'XLS' ||
        item.type == 'xlsx' ||
        item.type == 'XLSX' ||
        item.type == 'pot' ||
        item.type == 'POT' ||
        item.type == 'ppt' ||
        item.type == 'PPT' ||
        item.type == 'POTX' ||
        item.type == 'potx' ||
        item.type == 'doc' ||
        item.type == 'DOC' ||
        item.type == 'DOCX' ||
        item.type == 'docx'
      ) {
        window.open(
          'https://view.officeapps.live.com/op/view.aspx?src=' + item.url
        )
      } else {
        return this.$message.error('该类型文件无法预览')
      }
    },
    downloadFile(item) {
      // return console.log(item.url + '.' + item.type)
      window.open(item.url)
      // this.downloadIamge(item.url, item.name)
    },
    downloadIamge(imgsrc, name) {
      var image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        var canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        var context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        var url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
        var a = document.createElement('a') // 生成一个a元素
        var event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
    },
    // 获取七牛云token
    async getQiniuToken() {
      console.log('请求Qiniu Token 触发了')
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      const res = await this.$axios({
        method: 'post',
        url: '/api/Qiniu/qiniuToken',
        data: param,
      })
      this.postData.token = res.data
      // console.log('this.postData', res.data)
    },
    // 上传成功(七牛云)
    handleAvatarSuccess(res, file) {
      var imageUrl = this.upload_qiniu_addr + res.key
      this.fileList.push({
        name: file.name,
        type: file.name.split('.')[file.name.split('.').length - 1],
        url: imageUrl,
      })
      this.endLoading(file.name)
      console.log('***aftrer', this.loadingData)
      this.$emit('my-upload-change', this.fileList)
    },
    fileUpload() {},
    // 上传前(七牛云)
    beforeAvatarUpload(file) {
      // return console.log('file', file)

      const isLt2M = file.size / 1024 / 1024 < 500
      if (!isLt2M) {
        return this.$message.error('上传文件大小不能超过 500MB!')
      }
      this.postData.key =
        new Date().getTime().toString() +
        Math.random(6).toString() +
        '.' +
        file.name.split('.')[file.name.split('.').length - 1]
      console.log('***before', this.loadingData)
      this.startLoading(file.name)
    },
    // 上传失败(七牛云)
    handleError() {
      this.$message.error('文件上传失败')
      this.errorend()
    },
    // 加载动画
    startLoading(name) {
      let a = Loading.service({
        name: name,
        lock: true,
        text: '上传中……',
        background: 'rgba(255, 255, 255, .9)',
      })
      this.loadingData.push(a)
    },
    endLoading(name) {
      console.log(name)
      this.loadingData.forEach((item) => {
        if (item.name == name) {
          item.close()
          item = null
        }
      })
    },
    errorend() {
      this.loadingData.forEach((item) => {
        item.close()
        item = null
      })
    },
    removeItem(val) {
      let removeIndex = this.fileList.findIndex((item) => item.url === val.url)
      this.fileList.splice(removeIndex, 1)
      this.$emit('my-upload-change', this.fileList)
    },
    async handleBefore(file) {
      console.log('文件', file)

      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('file', file)
      const { data: res } = await this.$axios({
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/api/User/uploadImg',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success('上传成功')
      let nameArr = res.datas.img_url.split('/')
      let typeArr = res.datas.img_url.split('.')
      this.fileList.push({
        name: file.name,
        type: typeArr[typeArr.length - 1],
        url: res.datas.img_url,
      })
      console.log('12312312')
      this.$emit('my-upload-change', this.fileList)
    },
  },
  mounted() {
    if (this.imgList) {
      this.imgList.forEach((item) => {
        this.fileList.push(item)
      })
    }
  },
  created() {
    console.log('u')
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.getQiniuToken()
    this.loadingData = []
  },
  watch: {
    imgList(val, oldVal) {
      console.log('va111111111222', val)
      if (val) {
        this.fileList = val
      }
    },
    detailsImgList(val, oldVal) {
      if (val) {
        this.detailsImgList = val
        console.log('UploadFile-watch-detailsImgList', this.detailsImgList)
      }
    },
  },
}
</script>
<style lang="less" scoped>
#UpLoadFile {
  .fileList {
    width: 100%;
    font-size: 14px;
    color: #999;
    li {
      cursor: pointer;
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .FileBox {
        display: flex;

        box-sizing: border-box;
        width: calc(100% - 90px);
        border: 1px solid #ebebeb;
        height: 40px;
        // display: flex;
        line-height: 40px;
        align-items: center;
        padding-left: 20px;
        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分文字以...显示*/
        img {
          width: 17px;
          margin-right: 10px;
        }
      }
      /deep/.el-button {
        width: 60px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        color: #128bf1;
        border-color: #40a0f2;
        border-radius: 15px;
        margin-left: 30px;
      }
    }
  }
  /deep/.el-upload-list {
    display: none !important;
  }
}
/deep/.el-upload-dragger {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 30px;
  width: inherit;
  height: 40px;
}
.overFlowFileName {
  width: calc(100% - 30px);
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}
</style>